const e = {
  name: "CheckmarkSquare",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.9144 9.00003L10.5002 16.4142L6.08594 12L7.50015 10.5858L10.5002 13.5858L16.5002 7.58582L17.9144 9.00003Z" fill="currentColor"/>
<path d="M2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5ZM5 4C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4H5Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as CheckmarkSquare
};
